import { useState } from "react";
import { login } from "../../lib/api";

interface LoginModalProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess: () => void;
}

export function LoginModal({ isOpen, onClose, onSuccess }: LoginModalProps) {
	const [username, setUsername] = useState(import.meta.env.DEV ? "admin" : "");
	const [password, setPassword] = useState(
		import.meta.env.DEV ? "demo123" : "",
	);
	const [error, setError] = useState("");
	const [isLoading, setIsLoading] = useState(false);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setError("");
		setIsLoading(true);

		try {
			const response = await login(username, password);
			localStorage.setItem("adminToken", response.token);
			onSuccess();
			onClose();
		} catch (error) {
			setError(
				error instanceof Error ? error.message : "Nepodařilo se přihlásit",
			);
		} finally {
			setIsLoading(false);
		}
	};

	if (!isOpen) return null;

	return (
		<div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center">
			<div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
				<h2 className="text-2xl font-serif text-rose-800 mb-4">
					Administrátorský přístup
				</h2>

				<form onSubmit={handleSubmit} className="space-y-4">
					<div>
						<label className="block text-gray-700 mb-2" htmlFor="username">
							Uživatelské jméno
						</label>
						<input
							id="username"
							type="text"
							value={username}
							onChange={(e) => setUsername(e.target.value)}
							className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-rose-500 focus:border-transparent"
							required
						/>
					</div>

					<div>
						<label className="block text-gray-700 mb-2" htmlFor="password">
							Heslo
						</label>
						<input
							id="password"
							type="password"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-rose-500 focus:border-transparent"
							required
						/>
					</div>

					{error && <p className="text-red-500 text-sm">{error}</p>}

					<div className="flex justify-end gap-4">
						<button
							type="button"
							onClick={onClose}
							className="px-4 py-2 text-gray-600 hover:text-gray-800"
							disabled={isLoading}
						>
							Zrušit
						</button>
						<button
							type="submit"
							className="bg-rose-600 text-white px-6 py-2 rounded-md hover:bg-rose-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
							disabled={isLoading}
						>
							{isLoading ? "Přihlašuji..." : "Přihlásit"}
						</button>
					</div>
				</form>
			</div>
		</div>
	);
}
